import { lazy, Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Footer from './Footer';
import Header from './Header';
import OfflineBanner from './OfflineBanner';
import ScrollToTopButton from './common/ScrollToTopButton';

const TouchTargetOverlay = lazy(() => import('./common/TouchTargetOverlay'));

const Layout = () => {
  const location = useLocation();
  // Detect designer / mockup-demo route in either language. i18n-ignore: route slug.
  // location.pathname is percent-encoded for non-ASCII; decode before matching.
  const decoded = (() => {
    try {
      return decodeURIComponent(location.pathname);
    } catch {
      return location.pathname;
    }
  })();
  const isDesigner =
    /\/(?:bg|en)\/(?:дизайнер|mockup-demo)(?:\/|$)/.test(decoded) || // i18n-ignore: route slug
    decoded.startsWith('/дизайнер') || // i18n-ignore: route slug
    decoded.startsWith('/mockup-demo');

  const showOverlay =
    import.meta.env.DEV &&
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).has('debug-touch');

  return (
    <div className="flex flex-col min-h-screen bg-ivory">
      {!isDesigner && <Header />}
      <main className="flex-grow">
        <Outlet />
      </main>
      {!isDesigner && <Footer />}
      <OfflineBanner />
      <ScrollToTopButton />
      {showOverlay && (
        <Suspense fallback={null}>
          <TouchTargetOverlay />
        </Suspense>
      )}
    </div>
  );
};

export default Layout;
